module.exports = __webpack_public_path__ + "img/success.ea2d8cc0.png";